import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { issuesByIdVisibilityReducers, issuesByIdVisibilityWatchers } from './visibility';

export const issuesByIdReducers = combineReducers({
	visibility: issuesByIdVisibilityReducers
});

export const issuesByIdWatchers = combineAllWatchers([ issuesByIdVisibilityWatchers ]);
